import Errors from "../../utilities/constants/Errors";
import HttpClient from "../../utilities/functions/HttpClient";
import { CONTACT_ENDPOINT } from "../../utilities/constants/ServerEndPoints";

const getBackendErrorMessage = (error) => {
  const data = error?.response?.data;

  if (Array.isArray(data?.errors) && data.errors.length > 0) {
    return data.errors[0];
  }

  return data?.message || null;
};

/**
 * Submit a contact inquiry to the backend.
 * @param {Object} data - The contact form data
 * @param {string} data.name - Full name
 * @param {string} data.email - Email address
 * @param {string} data.subject - Subject
 * @param {string} data.message - Message
 * @returns {Promise} The API response
 */
export const submitContactInquiry = async (data) => {
  try {
    const response = await HttpClient.getAxiosClient().post(
      CONTACT_ENDPOINT,
      data,
    );
    return response.data;
  } catch (error) {
    const message =
      getBackendErrorMessage(error) ||
      (error?.response?.status === 503
        ? Errors.SERVICE_UNAVAILABLE_ERROR
        : Errors.API_ERROR);

    throw new Error(message, { cause: error });
  }
};
